import { Box } from '@mui/material';
import { SiteLogo } from './SiteLogo';

export const SiteHeader = (): JSX.Element => {
  return (
    <Box
      component='header'
      className='site-header'
      sx={{
        backgroundColor: '#1a1a1a',
        py: 2.5,
        px: 3,
        display: 'flex',
        justifyContent: 'center',
        color: '#ffffff'
      }}
    >
      <SiteLogo height={26} />
    </Box>
  );
};
